export const FILE_FORMATS = {
  PDF: 'PDF',
  DOCX: 'DOCX',
};

export const FILE_FORMAT_LABELS = {
  [FILE_FORMATS.PDF]: 'PDF',
  [FILE_FORMATS.DOCX]: 'Word',
};

export const BYTES_PER_MB = 1024 * 1024;
